module.exports = __webpack_public_path__ + "img/04-thumb.8812eb26.jpg";